import { useFlagConditionally } from '@mentimeter/flags/confidence/client';
import { LocalStorage } from '@mentimeter/storage';
export const APPLIED_QUICK_ACTION_KEY = 'applied-quick-action';

export const useEditorChecklistExperiment = (): boolean => {
  const shouldResolve =
    LocalStorage.getItem(APPLIED_QUICK_ACTION_KEY) === 'true';

  const { isReady, value: showEditorChecklist } = useFlagConditionally(
    shouldResolve,
    'nux-editor-checklist.enabled',
    false,
  );
  return isReady && showEditorChecklist;
};
